import { PlusSquareIcon } from '@phosphor-icons/react';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import { PageHeader } from '@/modules/common';
import { Routes } from '@/router/routes';

import { useCreateStyle } from '../api';
import { StyleForm } from '../components';

export const NewStylePage: FC = () => {
  const navigate = useNavigate();

  const { createStyleMutation, uploadUrlData, isFetching, refetchUploadUrl } =
    useCreateStyle();

  const saveStyle = async (data) => {
    if (uploadUrlData?.styleId) {
      try {
        await createStyleMutation.mutateAsync({
          ...data,
          id: uploadUrlData.styleId,
        });
        navigate(Routes.Styles, { replace: true });
        toast.success(`Style “${data.name}” added successfully!`);
      } catch (error) {
        console.error(error.message);
      }
    }
  };

  const refetchUploadCredentials = async () => {
    try {
      await refetchUploadUrl();
    } catch (error) {
      toast.error('Uh oh! Something went wrong.');
    }
  };

  return (
    <StyleForm
      onSubmit={saveStyle}
      uploadUrlData={uploadUrlData}
      refetchUploadCredentials={refetchUploadCredentials}
    >
      {({ isLoading }) => (
        <PageHeader
          title="New Style"
          asChildPage
          backPath={Routes.Styles}
          actions={[
            <Button
              key="create-style"
              type="submit"
              data-testid="create-style-button"
              isLoading={
                isFetching || createStyleMutation.isPending || isLoading
              }
              startIcon={<PlusSquareIcon />}
            >
              Create new style
            </Button>,
          ]}
        />
      )}
    </StyleForm>
  );
};
